<template>
  <v-snackbar
    v-model="show"
    bottom
    left
    :timeout="timeout"
    :color="color"
  >
    <v-icon
      v-if="error"
      color="error"
    >
      mdi-alert-circle
    </v-icon>

    <v-icon
      v-else
      color="success"
    >
      mdi-check-circle
    </v-icon>

    <span class="ml-2">{{ message }}</span>

    <v-btn
      dark
      text
      @click="show = false"
    >
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      message: '',
      error: false,
      timeout: 5000,
      color: null
    }
  },
  created () {
    this.$store.watch(state => state.alert.message, () => {
      const msg = this.$store.state.alert.message
      if (msg && msg !== {}) {
        this.show = true
        this.message = msg
        this.error = this.$store.state.alert.error
        this.$store.commit('notify')
      }
    })
  }
}
</script>
